<template>
  <div id="app">
    <md-sidenav :md-swipeable="true" class="md-left" ref="leftSidenav" v-if="this.$session.get('token')">
      <md-toolbar class="md-accent md-dense">
        <div class="md-toolbar-container">
          <h3 class="md-title">Menú</h3>
        </div>
      </md-toolbar>
      <md-list>
        <md-list-item>
          <router-link @click.native="cerrarNav()" to="/inicio">
            <md-icon>home</md-icon>
            <span>Inicio</span>
          </router-link>
        </md-list-item>
        <md-list-item>
          <router-link @click.native="cerrarNav()" to="/adelantos-nomina">
            <md-icon>money</md-icon>
            <span>Adelanto de nomina</span>
          </router-link>
        </md-list-item>
        <md-list-item>
          <md-icon>playlist_add_check</md-icon>
          <span>Asistencias</span>
          <md-list-expand>
            <md-list>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/asistencias">Tomar asistencia</router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/tiemposextra/asignar">Asignar tiempos extra</router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/tiemposextra/validar">Validar tiempos extra</router-link>
              </md-list-item>
            </md-list>
          </md-list-expand>
        </md-list-item>
        <md-list-item>
          <md-icon>contacts</md-icon>
          <span>Clientes</span>
          <md-list-expand>
            <md-list>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/clientes">Clientes registrados</router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/cliente">Registrar cliente</router-link>
              </md-list-item>
            </md-list>
          </md-list-expand>
        </md-list-item>
        <md-list-item>
          <md-icon>description</md-icon>
          <span>Contratos</span>
          <md-list-expand>
            <md-list>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/contratos">Contratos registrados</router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/contrato/nuevo">Registrar contrato</router-link>
              </md-list-item>
            </md-list>
          </md-list-expand>
        </md-list-item>
        <md-list-item>
          <md-icon>people</md-icon>
          <span>Empleados</span>
          <md-list-expand>
            <md-list>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/empleados">Empleados registrados</router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/empleado/nuevo">Registrar empleado</router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <span>Puestos</span>
                <md-list-expand>
                  <md-list>
                    <md-list-item class="md-inset">
                      <router-link @click.native="cerrarNav()" to="/puestos">Puestos registrados</router-link>
                    </md-list-item>
                    <md-list-item class="md-inset">
                      <router-link @click.native="cerrarNav()" to="/puesto/">Registrar puesto</router-link>
                    </md-list-item>
                  </md-list>
                </md-list-expand>
              </md-list-item>
            </md-list>
          </md-list-expand>
        </md-list-item>
        <!-- Nomina -->
        <md-list-item>
          <md-icon>attach_money</md-icon>
          <span>Nómina</span>
          <md-list-expand>
            <md-list>
              <md-list-item class="md-inset">
                <span>Adelantos de nómina</span>
                <md-list-expand>
                  <md-list>
                    <md-list-item class="md-inset">
                      <router-link @click.native="cerrarNav()" to="/adelantos">Registrar adelantos</router-link>
                    </md-list-item>
                    <md-list-item class="md-inset">
                      <router-link @click.native="cerrarNav()" to="/validar-adelantos">Validar adelantos</router-link>
                    </md-list-item>
                  </md-list>
                </md-list-expand>
              </md-list-item>
              <md-list-item class="md-inset">
                <span>Conceptos</span>
                <md-list-expand>
                  <md-list>
                    <md-list-item class="md-inset">
                      <router-link @click.native="cerrarNav()" to="/conceptos">Conceptos registrados</router-link>
                    </md-list-item>
                    <md-list-item class="md-inset">
                      <router-link @click.native="cerrarNav()" to="/concepto">Registrar concepto</router-link>
                    </md-list-item>
                  </md-list>
                </md-list-expand>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/nomina/diasfestivos">Días festivos</router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <span>Planes de pago</span>
                <md-list-expand>
                  <md-list>
                    <md-list-item class="md-inset">
                      <router-link @click.native="cerrarNav()" to="/planes">Planes de pago registrados</router-link>
                    </md-list-item>
                    <md-list-item class="md-inset">
                      <router-link @click.native="cerrarNav()" to="/plan">Registrar registrar plan de pago</router-link>
                    </md-list-item>
                  </md-list>
                </md-list-expand>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/nomina/resumen">Ver cálculo de nomina </router-link>
              </md-list-item>
              <md-list-item class="md-inset" @click.native="abrirModalCalcularNomina()"> Calcular nomina </md-list-item>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/">Cerrar nómina</router-link>
              </md-list-item>
            </md-list>
          </md-list-expand>
        </md-list-item>
        <md-list-item>
          <md-icon>location_searching</md-icon>
          <span>Puntos</span>
          <md-list-expand>
            <md-list>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/puntos">Puntos registrados</router-link>
              </md-list-item>
              <md-list-item class="md-inset">
                <router-link @click.native="cerrarNav()" to="/punto/cliente">Registrar punto</router-link>
              </md-list-item>
            </md-list>
          </md-list-expand>
        </md-list-item>
      </md-list>
    </md-sidenav>
    <div class="main-header fixed-toolbar">
      <md-whiteframe md-elevation="2">
        <md-toolbar class="md-dense">
          <div class="md-toolbar-container">
            <md-button class="md-icon-button" style="color:white" @click.native="abrirSideNavLeft()" v-if="this.$session.get('token')">
              <md-icon>menu</md-icon>
            </md-button>
            <h2 class="md-title" style="flex: 1; color:white">Grupo Alarcom</h2>
          </div>
        </md-toolbar>
      </md-whiteframe>
    </div>
    <router-view class="main-content"></router-view>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalCalcularNomina">
      <md-dialog-content>
        <div class="md-headline">¿Está seguro desea recalcular la nómina?</div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModalCalcularNomina(false)">Cancelar</md-button>
        <md-button class="md-raised md-primary" @click.native="cerrarModalCalcularNomina(true)">Calcular</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalCargando" :md-click-outside-to-close="false" :md-esc-to-close="false" style="z-index:9999!important">
      <md-progress md-indeterminate class="md-warn">Cargando</md-progress>
    </md-dialog>
  </div>
</template>
<script>
import Snackbar from "node-snackbar";
export default {
  name: "app",
  data() {
    return {
      permisos_editar_nomina: true,
      hay_sesion: this.$session.exists()
    };
  },
  methods: {
    abrirSideNavLeft() {
      this.$refs.leftSidenav.toggle();
    },
    cerrarNav() {
      this.$refs.leftSidenav.close();
    },
    abrirModalCalcularNomina() {
      this.cerrarNav();
      this.$refs["modalCalcularNomina"].open();
    },
    cerrarModalCalcularNomina(opcion) {
      this.cerrarNav();
      this.$refs["modalCalcularNomina"].close();
      if (opcion === true) {
        this.calcularNomina();
      }
    },
    calcularNomina() {
      this.$refs["modalCargando"].open();
      this.$http
        .post("nomina/calcular", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false
              });
              this.$router.push("/nomina/resumen");
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
            this.$refs["modalCargando"].close();
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
            this.$refs["modalCargando"].close();
          }
        );
    }
  }
};
</script>
<style>
body {
  background-color: #fafafa !important;
}

.img {
  width: 100%;
  height: auto;
}

.md-gutter-24 .md-column {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.m-b-24 {
  margin-bottom: 24px;
}

.m-t-24 {
  margin-top: 24px;
}

.m-t-16 {
  margin-top: 16px;
}

.m-t-16 {
  margin-top: 8px;
}

.w-100 {
  width: 100%;
}

.md-sidenav.md-active .md-sidenav-content {
  z-index: 9999;
}

.main-content {
  padding-top: 56px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  -ms-flex: 1;
  z-index: 1;
  flex: 1;
  overflow: auto;
  transform: translate3D(0, 0, 0);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-delay: 0.2s;
  margin-bottom: 24px;
}

.fixed-toolbar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9998;
  width: 100%;
}

.md-menu-content.md-direction-bottom-right.md-active {
  width: auto;
}

.btn-w-auto .md-button,
.md-menu-content.md-direction-bottom-right.md-active {
  width: auto !important;
}
</style>


// WEBPACK FOOTER //
// App.vue?0e428a47